module.exports = __webpack_public_path__ + "img/role-p-3.cfd16a70.png";